import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/app/error.tsx");
